export const expertStepEn = {
    zhuanjiatouxiang:"Expert profile：",
    shangchuantouxiang:"Upload the picture",
    zhuanjiamingcheng:"Name of expert：",
    xiangguanxinxi:"Please enter relevant information",
    zhuanjiafenglei:'Expert classification：',
    suozaidizhi:"Address of expert：",
    zhuanjiashanchang:"Experts are good at industries (multiple choices are available)：",
    xzschy:"Please choose the industry you are good at",
    lianxifangshi:"Contact information：",
    zjscqy:"Area of expertise for experts (multiple choices are available)：",
    xzrzfwgj:"Please select test certification service country",
    zjzl:"Professional qualifications：",
    zjjj:"Expert profile：",
    zjsfz:"Upload scanned copy of expert id card：",
    sfzzmsc:"Id card front upload",
    sfzfmsc:"Id card reverse upload",
    sczjzzzs:"Upload scanned copy of expert qualification certificate (multiple copies are optional)：",
    sczjgrlw:"Upload personal papers of experts：",
    jygzjl:"Education experience：",
    xieyi:"Agreement on TKTX product testing and certification platform"
    
}


// WEBPACK FOOTER //
// ./src/lang/home/expertStep/indexEn.js